import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import useCollectionState from 'Hooks/useCollectionState';
import FullScreenDataContainer
  from 'Components/ComponentLibrary/Components/Uncategorized/DataContainer/FullScreenDataContainer';
import { OldKYCIntroStepContainer } from './container';

export const OldKYCIntroStepTemplate = ({ resource }) => {
  const { loading, loadingError, collection } = useCollectionState({
    // If someone tries to render OldKYCIntroStepTemplate without the necessary relationship, there's nothing we can do but explode
    link: resource.relationship(fr.relationships.linkToken.name).link('related').url(),
  });

  return (
    <FullScreenDataContainer
      loading={loading}
      loadingError={loadingError}
      component={OldKYCIntroStepContainer}
      componentProps={{
        resource,
        linkTokenResource: collection ? collection.resources().head() : undefined,
      }}
    />
  );
};

OldKYCIntroStepTemplate.defaultProps = {
};

OldKYCIntroStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
